<template>
    <button :class="{ active: props.active }" :title="props.title" type="button">
        <i :class="props.icon"></i>
        <slot></slot>
    </button>
</template>

<script setup lang="ts">
    const props = defineProps<{
        title?: string;
        active: boolean;
        icon: string;
    }>();
</script>
